
import { Tab_Option, tab, Option, tabs } from "../../fable_modules/Fulma.3.0.0/Components/Tabs.fs.js";
import { waveformScrollerStyle, showWaveformsStyle, waveformColumnStyle, waveRowsStyle, cursorCycleHighlightSVG, plainTopRowLine, valuesColumnStyle, clkCycleNumberRowProps, endCycle, clkCycleText, singleWaveWidth, valueLabelStyle, valuesColumnSize, separatorColour, namesColBackground, topRow, namesColumnProps, nameLabelStyle, nameRowLevelLeftProps, nameRowLevelStyle, selectedWaves, eyeSvg, viewSymbolButtonStyle, radixTabAStyle, radixTabProps, radixTabsStyle } from "./WaveSimStyle.js";
import { max as max_1, collect, concat, append as append_1, length, insertManyAt, choose, exists, tryFind as tryFind_1, isEmpty, filter, empty, map, ofArray, singleton } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { int32ToString, safeHash, comparePrimitives, stringHash, defaultOf, compare, equals } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { WaveSimState, Msg, WaveSimModel } from "../../Model/ModelType.js";
import { HTMLAttr, DOMAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { BoundingBox, XYPos, NumberBase } from "../../Common/CommonTypes.js";
import { drawnComponentOf as drawnComponentOf_1 } from "../../Simulator/FastSim/PortView.js";
import { getFastSim } from "../../Simulator/Simulator.js";
import { tryPick, containsKey, toList, tryFind } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { getConnectedWireIds } from "../../DrawBlock/BusWireUpdateHelpers.js";
import { connsOfWave } from "./WaveSimHelpers.js";
import { sidecarIsRunning, sidecarIsBuilding, getWSModel } from "../ModelHelpers.js";
import { DrawModelType_SheetT_Msg, DrawModelType_Highlighted, DrawModelType_HighlightedModule_none } from "../../Model/DrawModelType.js";
import { contains, ofList } from "../../fable_modules/fable-library-js.5.13.0/Set.js";
import { min, max } from "../../fable_modules/fable-library-js.5.13.0/Double.js";
import { staleWaveformWarningMs, clkCycleNarrowThreshold, labelPadding, rowHeight, sheetLoadPollTries, sheetLoadPollMs } from "./WaveSimTypes.js";
import { openFileInProject } from "../MenuHelpers.js";
import { List_except, List_countBy } from "../../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { right, left, Level_Option, level } from "../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList as toList_1 } from "../../fable_modules/fable-library-js.5.13.0/Seq.js";
import { toArray, defaultArg } from "../../fable_modules/fable-library-js.5.13.0/Option.js";
import { Size_ISize, Common_GenericOption } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Option as Option_1, delete$ } from "../../fable_modules/Fulma.3.0.0/Elements/Delete.fs.js";
import { interpolate, concat as concat_1, join } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { fastDataToPaddedString } from "../../Simulator/NumberHelpers.js";
import { drawnFor, getWaveValue } from "./WaveSimSVGs.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.13.0/Range.js";
import { instrumentInterval, getTimeMs } from "../../Common/TimeHelpers.js";
import { dbg } from "../../Shared/Log.js";

/**
 * ReactElement of the tabs for changing displayed radix
 */
export function radixButtons(wsModel, dispatch) {
    return tabs(ofArray([Option.IsToggle, new Option(/* Props */ 8, [singleton(radixTabsStyle)])]), map((tupledArg) => {
        const radix = tupledArg[0];
        return tab(ofArray([new Tab_Option(/* IsActive */ 0, [equals(wsModel.Radix, radix)]), new Tab_Option(/* Props */ 2, [radixTabProps])]), singleton(react.createElement("a", keyValueList([radixTabAStyle, new DOMAttr(/* OnClick */ 40, [(_arg) => {
            dispatch(new Msg(/* GenerateWaveforms */ 14, [(wsModel_1) => (new WaveSimModel(wsModel_1.DefaultCursor, wsModel_1.WSConfig, wsModel_1.WSConfigDialog, wsModel_1.State, wsModel_1.WaveDetails, wsModel_1.SelectedWaves, wsModel_1.DefaultSelectionPending, wsModel_1.FetchFailedAtMs, wsModel_1.StartCycle, wsModel_1.ShownCycles, wsModel_1.SamplingZoom, wsModel_1.CursorDisplayCycle, wsModel_1.CursorExactClkCycle, wsModel_1.ClkCycleBoxIsEmpty, radix, wsModel_1.WaveformColumnWidth, wsModel_1.WaveModalActive, wsModel_1.RamModalActive, wsModel_1.PortSelectComp, wsModel_1.RamComps, wsModel_1.SelectedRams, wsModel_1.RamStartLocation, wsModel_1.RamRows, wsModel_1.ShowSheetDetail, wsModel_1.SelectedSheetInstance, wsModel_1.ShowGroupDetail, wsModel_1.HoveredLabel, wsModel_1.DraggedIndex, wsModel_1.PrevSelectedWaves, wsModel_1.ScrollbarTbWidth, wsModel_1.ScrollbarTbPos, wsModel_1.ScrollbarTbOffset, wsModel_1.ScrollbarBkgWidth, wsModel_1.ScrollbarBkgRepCycs, wsModel_1.ScrollbarQueueIsEmpty, wsModel_1.SheetSearchString, wsModel_1.ComponentSearchString, wsModel_1.PortSearchString, wsModel_1.ShowOnlySelected))]));
        }])], 1), tupledArg[1])));
    }, ofArray([[NumberBase.Bin, "Bin"], [NumberBase.Hex, "Hex"], [NumberBase.Dec, "uDec"], [NumberBase.SDec, "sDec"]])));
}

function drawnComponentOf(wi) {
    return drawnComponentOf_1(getFastSim().Design, wi);
}

function drawnCompsOf(model, wi) {
    const symbols = model.Sheet.Wire.Symbol.Symbols;
    const matchValue = tryFind(drawnComponentOf(wi), symbols);
    if (matchValue == null) {
        return empty();
    }
    else if (matchValue.Component.Type.tag === 3) {
        const lab = matchValue.Component.Label;
        return map((comp) => comp.Id, filter((_arg_1) => {
            let matchResult;
            if (_arg_1.Type.tag === 3) {
                if (_arg_1.Label === lab) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return true;
                default:
                    return false;
            }
        }, map((tupledArg) => tupledArg[1].Component, toList(symbols))));
    }
    else {
        return singleton(drawnComponentOf(wi));
    }
}

function netOfWave(model, wi) {
    if (!equals(drawnComponentOf(wi), wi.Id[0])) {
        return getConnectedWireIds(model.Sheet.Wire, drawnCompsOf(model, wi));
    }
    else {
        return filter((cid) => containsKey(cid, model.Sheet.Wire.Wires), connsOfWave(getFastSim(), wi));
    }
}

/**
 * What the schematic shows picked out because of the waveform viewer: the component a hovered
 * wave comes from, and the net that wave runs on.
 * 
 * **This is the whole of the hover highlight, and it is a function of the model.** SheetDisplay's
 * view is given the answer on every render, so there is no message that paints it and none that
 * has to remember to unpaint it: the highlight is on exactly while HoveredLabel names a wave and
 * off the instant it does not. That is also why it survives a change of sheet - the button that
 * takes the user to a wave's component leaves HoveredLabel alone, and the new sheet draws
 * whatever it has of the same net without being told.
 */
export function hoveredHighlight(model) {
    const ws = getWSModel(model);
    const matchValue = ws.HoveredLabel;
    let matchResult, wi_1;
    if (matchValue != null) {
        if (equals(ws.State, WaveSimState.Success) && equals(ws.DraggedIndex, undefined)) {
            matchResult = 0;
            wi_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_1 = drawnCompsOf(model, wi_1);
            if (isEmpty(matchValue_1)) {
                return DrawModelType_HighlightedModule_none;
            }
            else {
                return new DrawModelType_Highlighted(ofList(matchValue_1, {
                    Compare: (x, y) => (compare(x, y) | 0),
                }), ofList(netOfWave(model, wi_1), {
                    Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
                }));
            }
        }
        default:
            return DrawModelType_HighlightedModule_none;
    }
}

function visibleSheetArea(model) {
    const canvas = document.getElementById("Canvas");
    if (equals(canvas, defaultOf()) ? true : (model.Sheet.Zoom === 0)) {
        return undefined;
    }
    else {
        return new BoundingBox(new XYPos(canvas.scrollLeft / model.Sheet.Zoom, canvas.scrollTop / model.Sheet.Zoom), canvas.clientWidth / model.Sheet.Zoom, canvas.clientHeight / model.Sheet.Zoom);
    }
}

function symbolBoxOnOpenSheet(model, wave) {
    return tryFind(drawnComponentOf(wave.WaveId), model.Sheet.BoundingBoxes);
}

function centreOf(box) {
    return new XYPos(box.TopLeft.X + (box.W / 2), box.TopLeft.Y + (box.H / 2));
}

function symbolIsInView(model, wave) {
    const matchValue = symbolBoxOnOpenSheet(model, wave);
    const matchValue_1 = visibleSheetArea(model);
    let matchResult, box, view;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            box = matchValue;
            view = matchValue_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const centre = centreOf(box);
            if (((centre.X > view.TopLeft.X) && (centre.X < (view.TopLeft.X + view.W))) && (centre.Y > view.TopLeft.Y)) {
                return centre.Y < (view.TopLeft.Y + view.H);
            }
            else {
                return false;
            }
        }
        default:
            return false;
    }
}

function scrollToSymbol(wave, model, dispatch) {
    const matchValue = symbolBoxOnOpenSheet(model, wave);
    const matchValue_1 = visibleSheetArea(model);
    let matchResult, box, view;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            box = matchValue;
            view = matchValue_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const centre = centreOf(box);
            dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* UpdateScrollPos */ 11, [new XYPos(max(0, (centre.X - (view.W / 2)) * model.Sheet.Zoom), max(0, (centre.Y - (view.H / 2)) * model.Sheet.Zoom))])]));
            break;
        }
        case 1: {
            break;
        }
    }
}

function sheetOfComponent(model, wave) {
    const compId = drawnComponentOf(wave.WaveId);
    const option_3 = model.CurrentProj;
    if (option_3 != null) {
        const option_1 = tryFind_1((ldc) => exists((comp) => equals(comp.Id, compId), ldc.CanvasState[0]), option_3.LoadedComponents);
        if (option_1 != null) {
            return option_1.Name;
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}

function showWhenSheetLoaded(triesLeft, wave, dispatch) {
    dispatch(new Msg(/* DispatchDelayed */ 42, [[sheetLoadPollMs, new Msg(/* ExecFuncInMessage */ 116, [(model, dispatch_1) => {
        const matchValue = symbolBoxOnOpenSheet(model, wave);
        if (matchValue == null) {
            if (triesLeft > 0) {
                showWhenSheetLoaded(triesLeft - 1, wave, dispatch_1);
            }
        }
        else {
            scrollToSymbol(wave, model, dispatch_1);
        }
    }, dispatch])]]));
}

function showSymbolOfWave(wave, model, dispatch) {
    const matchValue = symbolBoxOnOpenSheet(model, wave);
    if (matchValue == null) {
        const matchValue_1 = sheetOfComponent(model, wave);
        const matchValue_2 = model.CurrentProj;
        let matchResult, project, sheet;
        if (matchValue_1 != null) {
            if (matchValue_2 != null) {
                matchResult = 0;
                project = matchValue_2;
                sheet = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                openFileInProject(sheet, project, model, dispatch);
                showWhenSheetLoaded(sheetLoadPollTries, wave, dispatch);
                break;
            }
            case 1: {
                break;
            }
        }
    }
    else {
        scrollToSymbol(wave, model, dispatch);
    }
}

function viewSymbolButton(model, wave, dispatch) {
    const isInView = symbolIsInView(model, wave);
    const props = [viewSymbolButtonStyle(isInView), new HTMLAttr(/* Draggable */ 81, [false]), new HTMLAttr(/* Title */ 158, [isInView ? "Centre this component on the schematic" : "Show this component: change sheet and scroll to it"]), new DOMAttr(/* OnClick */ 40, [(ev) => {
        ev.stopPropagation();
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, dispatch_1) => {
            showSymbolOfWave(wave, model_1, dispatch_1);
        }, dispatch]));
    }])];
    const children = [eyeSvg("white", "12px")];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

/**
 * Create label of waveform name for each selected wave.
 * Note that this is generated after calling selectedWaves. Any changes to this function
 * must also be made to valueRows and waveRows, as the order of the waves matters here.
 * This is because the wave viewer is comprised of three columns of many rows, rather
 * than many rows of three columns.
 */
export function nameRows(model, wsModel, dispatch) {
    const shown = selectedWaves(wsModel);
    const ambiguous = ofList(choose((tupledArg) => {
        if (tupledArg[1] > 1) {
            return tupledArg[0];
        }
        else {
            return undefined;
        }
    }, List_countBy((wave) => wave.ViewerDisplayName, shown, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
    return map((wave_1) => {
        let props;
        const visibility = equals(wsModel.HoveredLabel, wave_1.WaveId) ? "visible" : "hidden";
        return level(singleton(new Level_Option(/* Props */ 0, [toList_1(delay(() => append(singleton_1(nameRowLevelStyle(equals(wsModel.HoveredLabel, wave_1.WaveId))), delay(() => append(singleton_1(new DOMAttr(/* OnMouseOver */ 56, [(_arg_1) => {
            dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, _arg) => {
                ((model_2) => {
                    if (equals(getWSModel(model_2).DraggedIndex, undefined)) {
                        dispatch(new Msg(/* UpdateWSModel */ 13, [(ws) => (new WaveSimModel(ws.DefaultCursor, ws.WSConfig, ws.WSConfigDialog, ws.State, ws.WaveDetails, ws.SelectedWaves, ws.DefaultSelectionPending, ws.FetchFailedAtMs, ws.StartCycle, ws.ShownCycles, ws.SamplingZoom, ws.CursorDisplayCycle, ws.CursorExactClkCycle, ws.ClkCycleBoxIsEmpty, ws.Radix, ws.WaveformColumnWidth, ws.WaveModalActive, ws.RamModalActive, ws.PortSelectComp, ws.RamComps, ws.SelectedRams, ws.RamStartLocation, ws.RamRows, ws.ShowSheetDetail, ws.SelectedSheetInstance, ws.ShowGroupDetail, wave_1.WaveId, ws.DraggedIndex, ws.PrevSelectedWaves, ws.ScrollbarTbWidth, ws.ScrollbarTbPos, ws.ScrollbarTbOffset, ws.ScrollbarBkgWidth, ws.ScrollbarBkgRepCycs, ws.ScrollbarQueueIsEmpty, ws.SheetSearchString, ws.ComponentSearchString, ws.PortSearchString, ws.ShowOnlySelected))]));
                    }
                })(model_1);
            }, dispatch]));
        }])), delay(() => append(singleton_1(new DOMAttr(/* OnMouseOut */ 55, [(_arg_2) => {
            dispatch(new Msg(/* UpdateWSModel */ 13, [(ws_1) => (new WaveSimModel(ws_1.DefaultCursor, ws_1.WSConfig, ws_1.WSConfigDialog, ws_1.State, ws_1.WaveDetails, ws_1.SelectedWaves, ws_1.DefaultSelectionPending, ws_1.FetchFailedAtMs, ws_1.StartCycle, ws_1.ShownCycles, ws_1.SamplingZoom, ws_1.CursorDisplayCycle, ws_1.CursorExactClkCycle, ws_1.ClkCycleBoxIsEmpty, ws_1.Radix, ws_1.WaveformColumnWidth, ws_1.WaveModalActive, ws_1.RamModalActive, ws_1.PortSelectComp, ws_1.RamComps, ws_1.SelectedRams, ws_1.RamStartLocation, ws_1.RamRows, ws_1.ShowSheetDetail, ws_1.SelectedSheetInstance, ws_1.ShowGroupDetail, undefined, undefined, undefined, ws_1.ScrollbarTbWidth, ws_1.ScrollbarTbPos, ws_1.ScrollbarTbOffset, ws_1.ScrollbarBkgWidth, ws_1.ScrollbarBkgRepCycs, ws_1.ScrollbarQueueIsEmpty, ws_1.SheetSearchString, ws_1.ComponentSearchString, ws_1.PortSearchString, ws_1.ShowOnlySelected))]));
        }])), delay(() => append(singleton_1(new HTMLAttr(/* Draggable */ 81, [true])), delay(() => append(singleton_1(new DOMAttr(/* OnDragStart */ 49, [(ev) => {
            ev.dataTransfer.effectAllowed = "move";
            ev.dataTransfer.dropEffect = "move";
            dispatch(new Msg(/* UpdateWSModel */ 13, [(ws_2) => (new WaveSimModel(ws_2.DefaultCursor, ws_2.WSConfig, ws_2.WSConfigDialog, ws_2.State, ws_2.WaveDetails, ws_2.SelectedWaves, ws_2.DefaultSelectionPending, ws_2.FetchFailedAtMs, ws_2.StartCycle, ws_2.ShownCycles, ws_2.SamplingZoom, ws_2.CursorDisplayCycle, ws_2.CursorExactClkCycle, ws_2.ClkCycleBoxIsEmpty, ws_2.Radix, ws_2.WaveformColumnWidth, ws_2.WaveModalActive, ws_2.RamModalActive, ws_2.PortSelectComp, ws_2.RamComps, ws_2.SelectedRams, ws_2.RamStartLocation, ws_2.RamRows, ws_2.ShowSheetDetail, ws_2.SelectedSheetInstance, ws_2.ShowGroupDetail, ws_2.HoveredLabel, wave_1.WaveId, ws_2.SelectedWaves, ws_2.ScrollbarTbWidth, ws_2.ScrollbarTbPos, ws_2.ScrollbarTbOffset, ws_2.ScrollbarBkgWidth, ws_2.ScrollbarBkgRepCycs, ws_2.ScrollbarQueueIsEmpty, ws_2.SheetSearchString, ws_2.ComponentSearchString, ws_2.PortSearchString, ws_2.ShowOnlySelected))]));
        }])), delay(() => append(singleton_1(new DOMAttr(/* OnDrag */ 43, [(ev_1) => {
            ev_1.dataTransfer.dropEffect = "move";
            const nameColEl = document.getElementById("namesColumn");
            const bcr = nameColEl.getBoundingClientRect();
            if ((((ev_1.clientX < bcr.left) ? true : (ev_1.clientX > bcr.right)) ? true : (ev_1.clientY < bcr.top)) ? true : (ev_1.clientY > bcr.bottom)) {
                dispatch(new Msg(/* UpdateWSModel */ 13, [(ws_3) => (new WaveSimModel(ws_3.DefaultCursor, ws_3.WSConfig, ws_3.WSConfigDialog, ws_3.State, ws_3.WaveDetails, defaultArg(ws_3.PrevSelectedWaves, ws_3.SelectedWaves), ws_3.DefaultSelectionPending, ws_3.FetchFailedAtMs, ws_3.StartCycle, ws_3.ShownCycles, ws_3.SamplingZoom, ws_3.CursorDisplayCycle, ws_3.CursorExactClkCycle, ws_3.ClkCycleBoxIsEmpty, ws_3.Radix, ws_3.WaveformColumnWidth, ws_3.WaveModalActive, ws_3.RamModalActive, ws_3.PortSelectComp, ws_3.RamComps, ws_3.SelectedRams, ws_3.RamStartLocation, ws_3.RamRows, ws_3.ShowSheetDetail, ws_3.SelectedSheetInstance, ws_3.ShowGroupDetail, wave_1.WaveId, undefined, ws_3.PrevSelectedWaves, ws_3.ScrollbarTbWidth, ws_3.ScrollbarTbPos, ws_3.ScrollbarTbOffset, ws_3.ScrollbarBkgWidth, ws_3.ScrollbarBkgRepCycs, ws_3.ScrollbarQueueIsEmpty, ws_3.SheetSearchString, ws_3.ComponentSearchString, ws_3.PortSearchString, ws_3.ShowOnlySelected))]));
            }
        }])), delay(() => append(singleton_1(new DOMAttr(/* OnDragOver */ 48, [(ev_2) => {
            ev_2.preventDefault();
        }])), delay(() => append(singleton_1(new DOMAttr(/* OnDragEnter */ 45, [(ev_3) => {
            ev_3.preventDefault();
            ev_3.dataTransfer.dropEffect = "move";
            const nameColEl_1 = document.getElementById("namesColumn");
            const bcr_1 = nameColEl_1.getBoundingClientRect();
            const offsetY = ev_3.clientY - bcr_1.top;
            dispatch(new Msg(/* UpdateWSModel */ 13, [(ws_4) => {
                let e_3;
                const draggedWave = ofArray(toArray(ws_4.DraggedIndex));
                const others = List_except(draggedWave, ws_4.SelectedWaves, {
                    Equals: equals,
                    GetHashCode: (x_2) => (safeHash(x_2) | 0),
                });
                return new WaveSimModel(ws_4.DefaultCursor, ws_4.WSConfig, ws_4.WSConfigDialog, ws_4.State, ws_4.WaveDetails, insertManyAt((e_3 = (max(0, ~~(~~offsetY / rowHeight) - 1) | 0), min(length(others), e_3)), draggedWave, others), ws_4.DefaultSelectionPending, ws_4.FetchFailedAtMs, ws_4.StartCycle, ws_4.ShownCycles, ws_4.SamplingZoom, ws_4.CursorDisplayCycle, ws_4.CursorExactClkCycle, ws_4.ClkCycleBoxIsEmpty, ws_4.Radix, ws_4.WaveformColumnWidth, ws_4.WaveModalActive, ws_4.RamModalActive, ws_4.PortSelectComp, ws_4.RamComps, ws_4.SelectedRams, ws_4.RamStartLocation, ws_4.RamRows, ws_4.ShowSheetDetail, ws_4.SelectedSheetInstance, ws_4.ShowGroupDetail, ws_4.HoveredLabel, ws_4.DraggedIndex, ws_4.PrevSelectedWaves, ws_4.ScrollbarTbWidth, ws_4.ScrollbarTbPos, ws_4.ScrollbarTbOffset, ws_4.ScrollbarBkgWidth, ws_4.ScrollbarBkgRepCycs, ws_4.ScrollbarQueueIsEmpty, ws_4.SheetSearchString, ws_4.ComponentSearchString, ws_4.PortSearchString, ws_4.ShowOnlySelected);
            }]));
        }])), delay(() => singleton_1(new DOMAttr(/* OnDragEnd */ 44, [(_arg_3) => {
            dispatch(new Msg(/* UpdateWSModel */ 13, [(ws_5) => (new WaveSimModel(ws_5.DefaultCursor, ws_5.WSConfig, ws_5.WSConfigDialog, ws_5.State, ws_5.WaveDetails, ws_5.SelectedWaves, ws_5.DefaultSelectionPending, ws_5.FetchFailedAtMs, ws_5.StartCycle, ws_5.ShownCycles, ws_5.SamplingZoom, ws_5.CursorDisplayCycle, ws_5.CursorExactClkCycle, ws_5.ClkCycleBoxIsEmpty, ws_5.Radix, ws_5.WaveformColumnWidth, ws_5.WaveModalActive, ws_5.RamModalActive, ws_5.PortSelectComp, ws_5.RamComps, ws_5.SelectedRams, ws_5.RamStartLocation, ws_5.RamRows, ws_5.ShowSheetDetail, ws_5.SelectedSheetInstance, ws_5.ShowGroupDetail, ws_5.HoveredLabel, undefined, undefined, ws_5.ScrollbarTbWidth, ws_5.ScrollbarTbPos, ws_5.ScrollbarTbOffset, ws_5.ScrollbarBkgWidth, ws_5.ScrollbarBkgRepCycs, ws_5.ScrollbarQueueIsEmpty, ws_5.SheetSearchString, ws_5.ComponentSearchString, ws_5.PortSearchString, ws_5.ShowOnlySelected))]));
        }]))))))))))))))))))))])), ofArray([left(singleton(new Common_GenericOption(/* Props */ 1, [nameRowLevelLeftProps(visibility)])), ofArray([viewSymbolButton(model, wave_1, dispatch), delete$(ofArray([new Option_1(/* Size */ 0, [Size_ISize.IsSmall]), new Option_1(/* Props */ 1, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg_4) => {
            dispatch(new Msg(/* UpdateWSModel */ 13, [(ws_6) => (new WaveSimModel(ws_6.DefaultCursor, ws_6.WSConfig, ws_6.WSConfigDialog, ws_6.State, ws_6.WaveDetails, List_except([wave_1.WaveId], ws_6.SelectedWaves, {
                Equals: equals,
                GetHashCode: (x_3) => (safeHash(x_3) | 0),
            }), ws_6.DefaultSelectionPending, ws_6.FetchFailedAtMs, ws_6.StartCycle, ws_6.ShownCycles, ws_6.SamplingZoom, ws_6.CursorDisplayCycle, ws_6.CursorExactClkCycle, ws_6.ClkCycleBoxIsEmpty, ws_6.Radix, ws_6.WaveformColumnWidth, ws_6.WaveModalActive, ws_6.RamModalActive, ws_6.PortSelectComp, ws_6.RamComps, ws_6.SelectedRams, ws_6.RamStartLocation, ws_6.RamRows, ws_6.ShowSheetDetail, ws_6.SelectedSheetInstance, ws_6.ShowGroupDetail, ws_6.HoveredLabel, ws_6.DraggedIndex, ws_6.PrevSelectedWaves, ws_6.ScrollbarTbWidth, ws_6.ScrollbarTbPos, ws_6.ScrollbarTbOffset, ws_6.ScrollbarBkgWidth, ws_6.ScrollbarBkgRepCycs, ws_6.ScrollbarQueueIsEmpty, ws_6.SheetSearchString, ws_6.ComponentSearchString, ws_6.PortSearchString, ws_6.ShowOnlySelected))]));
        }]))])]), empty())])), right(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
            paddingRight: labelPadding,
        }])])), singleton((props = toList_1(delay(() => append(singleton_1(nameLabelStyle(equals(wsModel.HoveredLabel, wave_1.WaveId))), delay(() => (contains(wave_1.ViewerDisplayName, ambiguous) ? singleton_1(new HTMLAttr(/* Title */ 158, [join(".", append_1(wave_1.SubSheet, ofArray([wave_1.CompLabel, wave_1.PortLabel])))])) : empty_1()))))), react.createElement("label", keyValueList(props, 1), wave_1.ViewerDisplayName))))]));
    }, shown);
}

/**
 * Create column of waveform names
 */
export function namesColumn(model, wsModel, dispatch) {
    const rows = nameRows(model, wsModel, dispatch);
    const props = namesColumnProps(wsModel);
    const children = concat([topRow(wsModel, namesColBackground("transparent", [2, separatorColour, false]), []), rows]);
    return react.createElement("div", keyValueList(props, 1), ...children);
}

/**
 * Create label of waveform value for each selected wave at a given clk cycle.
 * Note that this is generated after calling selectedWaves.
 * Any changes to this function must also be made to nameRows
 * and waveRows, as the order of the waves matters here. This is
 * because the wave viewer is comprised of three columns of many
 * rows, rather than many rows of three columns.
 * Return required width of values column in pixels, and list of cloumn react elements.
 */
export function valueRows(wsModel) {
    const patternInput = valuesColumnSize(wsModel);
    return [patternInput[0], map((value) => {
        const props = [valueLabelStyle(wsModel)];
        return react.createElement("label", keyValueList(props, 1), value);
    }, map((fd) => {
        if (fd != null) {
            const fd_1 = fd;
            const matchValue_1 = fd_1.Dat;
            let matchResult;
            if (fd_1.Width === 1) {
                if (matchValue_1.tag === 0) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return ` ${matchValue_1.fields[0]}`;
                default:
                    return fastDataToPaddedString(patternInput[1], wsModel.Radix, fd_1);
            }
        }
        else {
            return " ?";
        }
    }, map((wave) => getWaveValue(wsModel, wave), selectedWaves(wsModel))))];
}

/**
 * Generate a row of numbers in the waveforms column.
 * Numbers correspond to clock cycles multiplied by the current multiplier
 */
export function clkCycleNumberRow(wsModel) {
    const children_2 = collect((i) => {
        let props, children;
        const n = (i * wsModel.SamplingZoom) | 0;
        const matchValue = singleWaveWidth(wsModel);
        if ((matchValue < clkCycleNarrowThreshold) && ((i % 5) !== 0)) {
            return empty();
        }
        else if (((n >= 1000) && (matchValue < ((clkCycleNarrowThreshold * 5) / 3))) && ((i % 10) !== 0)) {
            return empty();
        }
        else if (((n >= 10000) && (matchValue < ((clkCycleNarrowThreshold * 6) / 3))) && ((i % 10) !== 0)) {
            return empty();
        }
        else if (((n >= 100000) && (matchValue < ((clkCycleNarrowThreshold * 7) / 3))) && ((i % 10) !== 0)) {
            return empty();
        }
        else {
            return singleton((props = clkCycleText(wsModel, i), (children = [int32ToString(n)], react.createElement("text", keyValueList(props, 1), ...children))));
        }
    }, toList_1(rangeDouble(wsModel.StartCycle, 1, endCycle(wsModel))));
    const props_2 = clkCycleNumberRowProps(wsModel);
    return react.createElement("svg", keyValueList(props_2, 1), ...children_2);
}

function valuesColumn(wsModel) {
    let props, children;
    const patternInput = valueRows(wsModel);
    const topRowNumber = singleton((props = [["style", {
        fontSize: wsModel.WSConfig.FontSize,
        verticalAlign: "bottom",
        fontWeight: wsModel.WSConfig.FontWeight,
        paddingLeft: "4pt",
    }]], (children = [int32ToString(wsModel.CursorExactClkCycle)], react.createElement("div", keyValueList(props, 1), ...children))));
    const props_2 = [new HTMLAttr(/* Id */ 99, ["ValuesCol"]), valuesColumnStyle(wsModel, patternInput[0])];
    const children_2 = concat([topRow(wsModel, plainTopRowLine, topRowNumber), patternInput[1]]);
    return react.createElement("div", keyValueList(props_2, 1), ...children_2);
}

/**
 * Generate a column of waveforms corresponding to selected waves.
 */
export function waveformColumn(wsModel, dispatch) {
    let children_4, props_2, children_2;
    const start = getTimeMs();
    const waveRows = map((wave) => {
        const matchValue = drawnFor(wsModel, wave);
        if (matchValue == null) {
            return react.createElement("div", {});
        }
        else {
            return matchValue.Svg;
        }
    }, selectedWaves(wsModel));
    return instrumentInterval("waveformColumn", start, (children_4 = [cursorCycleHighlightSVG(wsModel, dispatch), (props_2 = [waveRowsStyle(wsModel)], (children_2 = append_1(singleton(clkCycleNumberRow(wsModel)), waveRows), react.createElement("div", keyValueList(props_2, 1), ...children_2)))], react.createElement("div", keyValueList([waveformColumnStyle], 1), ...children_4)));
}

/**
 * Display the names, waveforms, and values of selected waveforms
 */
export function showWaveforms(model, wsModel, dispatch) {
    let props_2, props_6, children_6, props_4;
    try {
        if (isEmpty(wsModel.SelectedWaves)) {
            return react.createElement("div", {});
        }
        else {
            let staleWarning;
            const outstanding = (model.CurrentViewport != null) && !equals(model.CurrentViewport, model.FetchedData);
            const sinceMs = max_1(ofArray([model.ViewportChangedAtMs, model.SidecarBuildEndedMs, model.SidecarRunEndedMs]), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            });
            const behindMs = getTimeMs() - sinceMs;
            const errorLatched = (model.FailedFetch != null) ? true : (wsModel.FetchFailedAtMs > 0);
            if (((equals(model.SpinnerPayload, undefined) && !sidecarIsBuilding(model)) && !sidecarIsRunning(model)) && (errorLatched ? true : (outstanding && (behindMs > staleWaveformWarningMs)))) {
                const message = errorLatched ? "The .NET simulator stopped answering for this view - its last reply was an error, and retries are paced. What is drawn is the last data that arrived, not what the cycle numbers above it say." : (`This view has been waiting ${interpolate("%.0f%P()", [behindMs / 1000])} seconds for its data. What is drawn is not what the cycle numbers above it say.`);
                staleWarning = singleton((props_2 = [["style", {
                    background: "#ffe0b2",
                    borderBottom: "1px solid #e69138",
                    color: "#7f4a00",
                    padding: "4px 8px",
                    fontSize: "12px",
                }]], react.createElement("div", keyValueList(props_2, 1), message)));
            }
            else {
                staleWarning = empty();
            }
            let runProgress;
            if (model.WaveScrollSettling ? true : !sidecarIsRunning(model)) {
                runProgress = empty();
            }
            else {
                const target = defaultArg(tryPick((_arg, op) => {
                    if (op.tag === 1) {
                        return op.fields[0];
                    }
                    else {
                        return undefined;
                    }
                }, model.SidecarInFlight), 0) | 0;
                let clock_1;
                const matchValue = model.SidecarSession;
                clock_1 = ((matchValue.tag === 1) ? matchValue.fields[3] : 0);
                runProgress = singleton((props_6 = [["style", {
                    background: "#e3f2fd",
                    borderBottom: "1px solid #64b5f6",
                    color: "#0d47a1",
                    padding: "4px 8px",
                    fontSize: "12px",
                }]], (children_6 = [`Simulating: cycle ${clock_1} of ${target}`, (props_4 = [["style", {
                    width: "40%",
                    height: "8px",
                    marginLeft: "12px",
                    verticalAlign: "middle",
                }], new HTMLAttr(/* Value */ 161, [int32ToString(clock_1)]), new HTMLAttr(/* Max */ 114, [int32ToString(max(1, target))])], react.createElement("progress", keyValueList(props_4, 1)))], react.createElement("div", keyValueList(props_6, 1), ...children_6))));
            }
            const children_10 = toList_1(delay(() => append(runProgress, delay(() => append(staleWarning, delay(() => {
                let children_8;
                return singleton_1((children_8 = [namesColumn(model, wsModel, dispatch), waveformColumn(wsModel, dispatch), valuesColumn(wsModel)], react.createElement("div", keyValueList([new HTMLAttr(/* Id */ 99, ["WaveCols"]), showWaveformsStyle], 1), ...children_8)));
            }))))));
            return react.createElement("div", keyValueList([new HTMLAttr(/* Id */ 99, ["Scroller"]), waveformScrollerStyle], 1), ...children_10);
        }
    }
    catch (ex) {
        dbg(64, concat_1("waveforms drawn after the simulation ended: ", ex.message));
        return react.createElement("div", {});
    }
}

